import { render, staticRenderFns } from "./ExtraClassDetailDialog.vue?vue&type=template&id=132ae5db"
import script from "./ExtraClassDetailDialog.vue?vue&type=script&lang=js"
export * from "./ExtraClassDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ExtraClassDetailDialog.vue?vue&type=style&index=0&id=132ae5db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports